<template>
  <div class="modal">
    <div class="modal__content">
      <slot />
<!--       <div v-if="$slots.actions" class="modal__actions">
        <slot name="actions" />
      </div> -->
      <button type="button" class="modal__close" @click="$emit('click:close')">
        <span class="visually-hidden">Закрыть окно</span>
        <BaseIcon name="cross" class="modal__cross" />
      </button>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';

export default {
  name: 'BaseModal',
  components: {
    BaseIcon,
  },
};
</script>

<style lang="stylus">
.modal
  display flex
  flex-flow row wrap
  //align-items center
  justify-content center
  background-color alpha(#132a40, 50%)
  overflow-y auto
  overflow-x hidden
  // background-color rgba(19, 42, 64, 0.4);
  padding 1.6em 1.2em

  &__content
    align-self flex-start
    position relative
    display block
    width 24em
    max-width 100%
    padding 1.5em 1.8em
    //text-align center
    background-color #fff
    box-shadow 0 0 2em alpha(#000, 25%)
    border-radius 1em
    +landscape()
      padding 1.6em 3em

  &__close
    abs top left 100%
    display flex
    align-items center
    justify-content center
    width 2em
    height @width
    //padding 0.6em
    background $c_bright//#f9f9f9
    color #fff//$c_bright
    border 0
    margin (@width / 2 * -1) 0 0 (@width / 2 * -1)
    border-radius 50%
    outline none
    z-index 3
    &:focus
    &:hover
      background-color #4064D4

  &__cross
    width 0.8em
    height @width

  &__title
    margin-bottom 1em
    +landscape()
      margin-bottom 1.5em

  &__skip
    width 100%
    margin-top 1em

  // &__actions
  //   display flex
  //   flex-flow row wrap
  //   align-items center
  //   justify-content space-between
  //   margin-top 2em

  // &__action
  //   width 45%
</style>
